import { SocketContext } from "providers/socket.provider";
import { useContext, useEffect, useState } from "react";

const useSocket = () => {
    const context = useContext(SocketContext);

    if (!context) {
        throw new Error("useSocket must be used within a SocketProvider");
    }

  const { socket, registerConsumer } = context || {};
    const [isConnected, setIsConnected] = useState(socket?.connected || false);

  // Register active consumer: connects socket on mount, disconnects when all consumers unmount
    useEffect(() => {
      if (registerConsumer) {
        return registerConsumer();
      }
    }, [registerConsumer]);

  useEffect(() => {
    if (!socket) {
      setIsConnected(false);
      return;
    }

    setIsConnected(socket.connected || false);

        const onConnect = () => setIsConnected(true);
        const onDisconnect = () => setIsConnected(false);

        socket.on("connect", onConnect);
        socket.on("disconnect", onDisconnect);

        return () => {
            socket.off("connect", onConnect);
            socket.off("disconnect", onDisconnect);
        };
    }, [socket]);

    return { isConnected, socket };
};

export default useSocket;
